module.exports = __webpack_public_path__ + "img/Deletefile.5e81f34f.svg";